module.exports = __webpack_public_path__ + "img/star_icon.7042927e.svg";